/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LangImport } from './routes/$lang'
import { Route as LangIndexImport } from './routes/$lang/index'
import { Route as LangThankYouImport } from './routes/$lang/thankYou'
import { Route as LangServerErrorImport } from './routes/$lang/serverError'
import { Route as LangRtkImport } from './routes/$lang/rtk'
import { Route as LangProgramsImport } from './routes/$lang/programs'
import { Route as LangPolicyImport } from './routes/$lang/policy'
import { Route as LangPaymentProcessingImport } from './routes/$lang/payment-processing'
import { Route as LangNotfoundImport } from './routes/$lang/notfound'
import { Route as LangMaintenanceImport } from './routes/$lang/maintenance'
import { Route as LangJoinUsImport } from './routes/$lang/join-us'
import { Route as LangFatawaImport } from './routes/$lang/fatawa'
import { Route as LangFaqsImport } from './routes/$lang/faqs'
import { Route as LangDonorProfileImport } from './routes/$lang/donor-profile'
import { Route as LangDonateNowImport } from './routes/$lang/donate-now'
import { Route as LangContactImport } from './routes/$lang/contact'
import { Route as LangCommunityChallengeImport } from './routes/$lang/community-challenge'
import { Route as LangCohImport } from './routes/$lang/coh'
import { Route as LangCircleCreationImport } from './routes/$lang/circle-creation'
import { Route as LangBlogsImport } from './routes/$lang/blogs'
import { Route as LangBetaFeaturesImport } from './routes/$lang/beta-features'
import { Route as LangAboutUsImport } from './routes/$lang/about-us'
import { Route as LangProgramProgramIdImport } from './routes/$lang/program.$programId'
import { Route as LangPaymentFlowProgramIdImport } from './routes/$lang/paymentFlow.$programId'
import { Route as LangGratitudeProgramIdImport } from './routes/$lang/gratitude.$programId'
import { Route as LangFatwaFatwaIdImport } from './routes/$lang/fatwa.$fatwaId'
import { Route as LangCircleCircleIdImport } from './routes/$lang/circle.$circleId'
import { Route as LangChallengeChallengeIdImport } from './routes/$lang/challenge.$challengeId'
import { Route as LangChallengePaymentChallengeIdImport } from './routes/$lang/challenge-payment.$challengeId'
import { Route as LangChallengeCheckoutChallengeIdImport } from './routes/$lang/challenge-checkout.$challengeId'
import { Route as LangBlogBlogIdImport } from './routes/$lang/blog.$blogId'

// Create/Update Routes

const LangRoute = LangImport.update({
  path: '/$lang',
  getParentRoute: () => rootRoute,
} as any)

const LangIndexRoute = LangIndexImport.update({
  path: '/',
  getParentRoute: () => LangRoute,
} as any)

const LangThankYouRoute = LangThankYouImport.update({
  path: '/thankYou',
  getParentRoute: () => LangRoute,
} as any)

const LangServerErrorRoute = LangServerErrorImport.update({
  path: '/serverError',
  getParentRoute: () => LangRoute,
} as any)

const LangRtkRoute = LangRtkImport.update({
  path: '/rtk',
  getParentRoute: () => LangRoute,
} as any)

const LangProgramsRoute = LangProgramsImport.update({
  path: '/programs',
  getParentRoute: () => LangRoute,
} as any)

const LangPolicyRoute = LangPolicyImport.update({
  path: '/policy',
  getParentRoute: () => LangRoute,
} as any)

const LangPaymentProcessingRoute = LangPaymentProcessingImport.update({
  path: '/payment-processing',
  getParentRoute: () => LangRoute,
} as any)

const LangNotfoundRoute = LangNotfoundImport.update({
  path: '/notfound',
  getParentRoute: () => LangRoute,
} as any)

const LangMaintenanceRoute = LangMaintenanceImport.update({
  path: '/maintenance',
  getParentRoute: () => LangRoute,
} as any)

const LangJoinUsRoute = LangJoinUsImport.update({
  path: '/join-us',
  getParentRoute: () => LangRoute,
} as any)

const LangFatawaRoute = LangFatawaImport.update({
  path: '/fatawa',
  getParentRoute: () => LangRoute,
} as any)

const LangFaqsRoute = LangFaqsImport.update({
  path: '/faqs',
  getParentRoute: () => LangRoute,
} as any)

const LangDonorProfileRoute = LangDonorProfileImport.update({
  path: '/donor-profile',
  getParentRoute: () => LangRoute,
} as any)

const LangDonateNowRoute = LangDonateNowImport.update({
  path: '/donate-now',
  getParentRoute: () => LangRoute,
} as any)

const LangContactRoute = LangContactImport.update({
  path: '/contact',
  getParentRoute: () => LangRoute,
} as any)

const LangCommunityChallengeRoute = LangCommunityChallengeImport.update({
  path: '/community-challenge',
  getParentRoute: () => LangRoute,
} as any)

const LangCohRoute = LangCohImport.update({
  path: '/coh',
  getParentRoute: () => LangRoute,
} as any)

const LangCircleCreationRoute = LangCircleCreationImport.update({
  path: '/circle-creation',
  getParentRoute: () => LangRoute,
} as any)

const LangBlogsRoute = LangBlogsImport.update({
  path: '/blogs',
  getParentRoute: () => LangRoute,
} as any)

const LangBetaFeaturesRoute = LangBetaFeaturesImport.update({
  path: '/beta-features',
  getParentRoute: () => LangRoute,
} as any)

const LangAboutUsRoute = LangAboutUsImport.update({
  path: '/about-us',
  getParentRoute: () => LangRoute,
} as any)

const LangProgramProgramIdRoute = LangProgramProgramIdImport.update({
  path: '/program/$programId',
  getParentRoute: () => LangRoute,
} as any)

const LangPaymentFlowProgramIdRoute = LangPaymentFlowProgramIdImport.update({
  path: '/paymentFlow/$programId',
  getParentRoute: () => LangRoute,
} as any)

const LangGratitudeProgramIdRoute = LangGratitudeProgramIdImport.update({
  path: '/gratitude/$programId',
  getParentRoute: () => LangRoute,
} as any)

const LangFatwaFatwaIdRoute = LangFatwaFatwaIdImport.update({
  path: '/fatwa/$fatwaId',
  getParentRoute: () => LangRoute,
} as any)

const LangCircleCircleIdRoute = LangCircleCircleIdImport.update({
  path: '/circle/$circleId',
  getParentRoute: () => LangRoute,
} as any)

const LangChallengeChallengeIdRoute = LangChallengeChallengeIdImport.update({
  path: '/challenge/$challengeId',
  getParentRoute: () => LangRoute,
} as any)

const LangChallengePaymentChallengeIdRoute =
  LangChallengePaymentChallengeIdImport.update({
    path: '/challenge-payment/$challengeId',
    getParentRoute: () => LangRoute,
  } as any)

const LangChallengeCheckoutChallengeIdRoute =
  LangChallengeCheckoutChallengeIdImport.update({
    path: '/challenge-checkout/$challengeId',
    getParentRoute: () => LangRoute,
  } as any)

const LangBlogBlogIdRoute = LangBlogBlogIdImport.update({
  path: '/blog/$blogId',
  getParentRoute: () => LangRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangImport
      parentRoute: typeof rootRoute
    }
    '/$lang/about-us': {
      id: '/$lang/about-us'
      path: '/about-us'
      fullPath: '/$lang/about-us'
      preLoaderRoute: typeof LangAboutUsImport
      parentRoute: typeof LangImport
    }
    '/$lang/beta-features': {
      id: '/$lang/beta-features'
      path: '/beta-features'
      fullPath: '/$lang/beta-features'
      preLoaderRoute: typeof LangBetaFeaturesImport
      parentRoute: typeof LangImport
    }
    '/$lang/blogs': {
      id: '/$lang/blogs'
      path: '/blogs'
      fullPath: '/$lang/blogs'
      preLoaderRoute: typeof LangBlogsImport
      parentRoute: typeof LangImport
    }
    '/$lang/circle-creation': {
      id: '/$lang/circle-creation'
      path: '/circle-creation'
      fullPath: '/$lang/circle-creation'
      preLoaderRoute: typeof LangCircleCreationImport
      parentRoute: typeof LangImport
    }
    '/$lang/coh': {
      id: '/$lang/coh'
      path: '/coh'
      fullPath: '/$lang/coh'
      preLoaderRoute: typeof LangCohImport
      parentRoute: typeof LangImport
    }
    '/$lang/community-challenge': {
      id: '/$lang/community-challenge'
      path: '/community-challenge'
      fullPath: '/$lang/community-challenge'
      preLoaderRoute: typeof LangCommunityChallengeImport
      parentRoute: typeof LangImport
    }
    '/$lang/contact': {
      id: '/$lang/contact'
      path: '/contact'
      fullPath: '/$lang/contact'
      preLoaderRoute: typeof LangContactImport
      parentRoute: typeof LangImport
    }
    '/$lang/donate-now': {
      id: '/$lang/donate-now'
      path: '/donate-now'
      fullPath: '/$lang/donate-now'
      preLoaderRoute: typeof LangDonateNowImport
      parentRoute: typeof LangImport
    }
    '/$lang/donor-profile': {
      id: '/$lang/donor-profile'
      path: '/donor-profile'
      fullPath: '/$lang/donor-profile'
      preLoaderRoute: typeof LangDonorProfileImport
      parentRoute: typeof LangImport
    }
    '/$lang/faqs': {
      id: '/$lang/faqs'
      path: '/faqs'
      fullPath: '/$lang/faqs'
      preLoaderRoute: typeof LangFaqsImport
      parentRoute: typeof LangImport
    }
    '/$lang/fatawa': {
      id: '/$lang/fatawa'
      path: '/fatawa'
      fullPath: '/$lang/fatawa'
      preLoaderRoute: typeof LangFatawaImport
      parentRoute: typeof LangImport
    }
    '/$lang/join-us': {
      id: '/$lang/join-us'
      path: '/join-us'
      fullPath: '/$lang/join-us'
      preLoaderRoute: typeof LangJoinUsImport
      parentRoute: typeof LangImport
    }
    '/$lang/maintenance': {
      id: '/$lang/maintenance'
      path: '/maintenance'
      fullPath: '/$lang/maintenance'
      preLoaderRoute: typeof LangMaintenanceImport
      parentRoute: typeof LangImport
    }
    '/$lang/notfound': {
      id: '/$lang/notfound'
      path: '/notfound'
      fullPath: '/$lang/notfound'
      preLoaderRoute: typeof LangNotfoundImport
      parentRoute: typeof LangImport
    }
    '/$lang/payment-processing': {
      id: '/$lang/payment-processing'
      path: '/payment-processing'
      fullPath: '/$lang/payment-processing'
      preLoaderRoute: typeof LangPaymentProcessingImport
      parentRoute: typeof LangImport
    }
    '/$lang/policy': {
      id: '/$lang/policy'
      path: '/policy'
      fullPath: '/$lang/policy'
      preLoaderRoute: typeof LangPolicyImport
      parentRoute: typeof LangImport
    }
    '/$lang/programs': {
      id: '/$lang/programs'
      path: '/programs'
      fullPath: '/$lang/programs'
      preLoaderRoute: typeof LangProgramsImport
      parentRoute: typeof LangImport
    }
    '/$lang/rtk': {
      id: '/$lang/rtk'
      path: '/rtk'
      fullPath: '/$lang/rtk'
      preLoaderRoute: typeof LangRtkImport
      parentRoute: typeof LangImport
    }
    '/$lang/serverError': {
      id: '/$lang/serverError'
      path: '/serverError'
      fullPath: '/$lang/serverError'
      preLoaderRoute: typeof LangServerErrorImport
      parentRoute: typeof LangImport
    }
    '/$lang/thankYou': {
      id: '/$lang/thankYou'
      path: '/thankYou'
      fullPath: '/$lang/thankYou'
      preLoaderRoute: typeof LangThankYouImport
      parentRoute: typeof LangImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexImport
      parentRoute: typeof LangImport
    }
    '/$lang/blog/$blogId': {
      id: '/$lang/blog/$blogId'
      path: '/blog/$blogId'
      fullPath: '/$lang/blog/$blogId'
      preLoaderRoute: typeof LangBlogBlogIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/challenge-checkout/$challengeId': {
      id: '/$lang/challenge-checkout/$challengeId'
      path: '/challenge-checkout/$challengeId'
      fullPath: '/$lang/challenge-checkout/$challengeId'
      preLoaderRoute: typeof LangChallengeCheckoutChallengeIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/challenge-payment/$challengeId': {
      id: '/$lang/challenge-payment/$challengeId'
      path: '/challenge-payment/$challengeId'
      fullPath: '/$lang/challenge-payment/$challengeId'
      preLoaderRoute: typeof LangChallengePaymentChallengeIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/challenge/$challengeId': {
      id: '/$lang/challenge/$challengeId'
      path: '/challenge/$challengeId'
      fullPath: '/$lang/challenge/$challengeId'
      preLoaderRoute: typeof LangChallengeChallengeIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/circle/$circleId': {
      id: '/$lang/circle/$circleId'
      path: '/circle/$circleId'
      fullPath: '/$lang/circle/$circleId'
      preLoaderRoute: typeof LangCircleCircleIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/fatwa/$fatwaId': {
      id: '/$lang/fatwa/$fatwaId'
      path: '/fatwa/$fatwaId'
      fullPath: '/$lang/fatwa/$fatwaId'
      preLoaderRoute: typeof LangFatwaFatwaIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/gratitude/$programId': {
      id: '/$lang/gratitude/$programId'
      path: '/gratitude/$programId'
      fullPath: '/$lang/gratitude/$programId'
      preLoaderRoute: typeof LangGratitudeProgramIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/paymentFlow/$programId': {
      id: '/$lang/paymentFlow/$programId'
      path: '/paymentFlow/$programId'
      fullPath: '/$lang/paymentFlow/$programId'
      preLoaderRoute: typeof LangPaymentFlowProgramIdImport
      parentRoute: typeof LangImport
    }
    '/$lang/program/$programId': {
      id: '/$lang/program/$programId'
      path: '/program/$programId'
      fullPath: '/$lang/program/$programId'
      preLoaderRoute: typeof LangProgramProgramIdImport
      parentRoute: typeof LangImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  LangRoute: LangRoute.addChildren({
    LangAboutUsRoute,
    LangBetaFeaturesRoute,
    LangBlogsRoute,
    LangCircleCreationRoute,
    LangCohRoute,
    LangCommunityChallengeRoute,
    LangContactRoute,
    LangDonateNowRoute,
    LangDonorProfileRoute,
    LangFaqsRoute,
    LangFatawaRoute,
    LangJoinUsRoute,
    LangMaintenanceRoute,
    LangNotfoundRoute,
    LangPaymentProcessingRoute,
    LangPolicyRoute,
    LangProgramsRoute,
    LangRtkRoute,
    LangServerErrorRoute,
    LangThankYouRoute,
    LangIndexRoute,
    LangBlogBlogIdRoute,
    LangChallengeCheckoutChallengeIdRoute,
    LangChallengePaymentChallengeIdRoute,
    LangChallengeChallengeIdRoute,
    LangCircleCircleIdRoute,
    LangFatwaFatwaIdRoute,
    LangGratitudeProgramIdRoute,
    LangPaymentFlowProgramIdRoute,
    LangProgramProgramIdRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/$lang"
      ]
    },
    "/$lang": {
      "filePath": "$lang.tsx",
      "children": [
        "/$lang/about-us",
        "/$lang/beta-features",
        "/$lang/blogs",
        "/$lang/circle-creation",
        "/$lang/coh",
        "/$lang/community-challenge",
        "/$lang/contact",
        "/$lang/donate-now",
        "/$lang/donor-profile",
        "/$lang/faqs",
        "/$lang/fatawa",
        "/$lang/join-us",
        "/$lang/maintenance",
        "/$lang/notfound",
        "/$lang/payment-processing",
        "/$lang/policy",
        "/$lang/programs",
        "/$lang/rtk",
        "/$lang/serverError",
        "/$lang/thankYou",
        "/$lang/",
        "/$lang/blog/$blogId",
        "/$lang/challenge-checkout/$challengeId",
        "/$lang/challenge-payment/$challengeId",
        "/$lang/challenge/$challengeId",
        "/$lang/circle/$circleId",
        "/$lang/fatwa/$fatwaId",
        "/$lang/gratitude/$programId",
        "/$lang/paymentFlow/$programId",
        "/$lang/program/$programId"
      ]
    },
    "/$lang/about-us": {
      "filePath": "$lang/about-us.tsx",
      "parent": "/$lang"
    },
    "/$lang/beta-features": {
      "filePath": "$lang/beta-features.tsx",
      "parent": "/$lang"
    },
    "/$lang/blogs": {
      "filePath": "$lang/blogs.tsx",
      "parent": "/$lang"
    },
    "/$lang/circle-creation": {
      "filePath": "$lang/circle-creation.tsx",
      "parent": "/$lang"
    },
    "/$lang/coh": {
      "filePath": "$lang/coh.tsx",
      "parent": "/$lang"
    },
    "/$lang/community-challenge": {
      "filePath": "$lang/community-challenge.tsx",
      "parent": "/$lang"
    },
    "/$lang/contact": {
      "filePath": "$lang/contact.tsx",
      "parent": "/$lang"
    },
    "/$lang/donate-now": {
      "filePath": "$lang/donate-now.tsx",
      "parent": "/$lang"
    },
    "/$lang/donor-profile": {
      "filePath": "$lang/donor-profile.tsx",
      "parent": "/$lang"
    },
    "/$lang/faqs": {
      "filePath": "$lang/faqs.tsx",
      "parent": "/$lang"
    },
    "/$lang/fatawa": {
      "filePath": "$lang/fatawa.tsx",
      "parent": "/$lang"
    },
    "/$lang/join-us": {
      "filePath": "$lang/join-us.tsx",
      "parent": "/$lang"
    },
    "/$lang/maintenance": {
      "filePath": "$lang/maintenance.tsx",
      "parent": "/$lang"
    },
    "/$lang/notfound": {
      "filePath": "$lang/notfound.tsx",
      "parent": "/$lang"
    },
    "/$lang/payment-processing": {
      "filePath": "$lang/payment-processing.tsx",
      "parent": "/$lang"
    },
    "/$lang/policy": {
      "filePath": "$lang/policy.tsx",
      "parent": "/$lang"
    },
    "/$lang/programs": {
      "filePath": "$lang/programs.tsx",
      "parent": "/$lang"
    },
    "/$lang/rtk": {
      "filePath": "$lang/rtk.tsx",
      "parent": "/$lang"
    },
    "/$lang/serverError": {
      "filePath": "$lang/serverError.tsx",
      "parent": "/$lang"
    },
    "/$lang/thankYou": {
      "filePath": "$lang/thankYou.tsx",
      "parent": "/$lang"
    },
    "/$lang/": {
      "filePath": "$lang/index.tsx",
      "parent": "/$lang"
    },
    "/$lang/blog/$blogId": {
      "filePath": "$lang/blog.$blogId.tsx",
      "parent": "/$lang"
    },
    "/$lang/challenge-checkout/$challengeId": {
      "filePath": "$lang/challenge-checkout.$challengeId.tsx",
      "parent": "/$lang"
    },
    "/$lang/challenge-payment/$challengeId": {
      "filePath": "$lang/challenge-payment.$challengeId.tsx",
      "parent": "/$lang"
    },
    "/$lang/challenge/$challengeId": {
      "filePath": "$lang/challenge.$challengeId.tsx",
      "parent": "/$lang"
    },
    "/$lang/circle/$circleId": {
      "filePath": "$lang/circle.$circleId.tsx",
      "parent": "/$lang"
    },
    "/$lang/fatwa/$fatwaId": {
      "filePath": "$lang/fatwa.$fatwaId.tsx",
      "parent": "/$lang"
    },
    "/$lang/gratitude/$programId": {
      "filePath": "$lang/gratitude.$programId.tsx",
      "parent": "/$lang"
    },
    "/$lang/paymentFlow/$programId": {
      "filePath": "$lang/paymentFlow.$programId.tsx",
      "parent": "/$lang"
    },
    "/$lang/program/$programId": {
      "filePath": "$lang/program.$programId.tsx",
      "parent": "/$lang"
    }
  }
}
ROUTE_MANIFEST_END */
